import { LoadingButton } from "@mui/lab";
import { Box, Divider, TextField, Typography } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { dispatch } from "store";
import { updateGlobalOffersThunk } from "store/reducers/global_offers/globalOffersSlice";

const OfferImageDialog = ({ open, handleClose, item }) => {
  const [image, setImage] = useState("");

  const updateOfferImage = () => {
    dispatch(
      updateGlobalOffersThunk({
        id: item.id,
        data: { offer_announcement_image: image },
      })
    );
  };

  const { status } = useSelector((state) => state.globalOffers);
  return (
    <CustomDialog open={open} handleClose={handleClose} heading="Offer image">
      <Box sx={{ margin: 2, minWidth: 400 }}>
        {item.offer_announcement_image ? (
          <img
            src={item.offer_announcement_image}
            alt="Offer Announcement"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        ) : (
          <Typography>No image</Typography>
        )}

        <Divider />
        <Box sx={{ mt: 4 }}>
          <TextField
            label="Offer announcement image"
            variant="outlined"
            name="offer_announcement_image"
            fullWidth
            autoComplete="off"
            type="file"
            InputLabelProps={{ shrink: true }}
            InputProps={{
              inputProps: { accept: "image/*" },
              onChange: (event) => {
                setImage(event.currentTarget.files[0]);
              },
            }}
          />
          <LoadingButton
            variant="contained"
            type="submit"
            sx={{ paddingX: 10, marginTop: 1 }}
            loading={status?.loading === "update"}
            onClick={updateOfferImage}
          >
            Update
          </LoadingButton>
        </Box>
      </Box>
    </CustomDialog>
  );
};

export default OfferImageDialog;
